/*
  Gift options in the cart drawer.

  Writes the same four line item properties the product form sets, onto every
  line in the cart, through the Cart AJAX API. One parcel gets one gift
  message, so the values are applied uniformly rather than per line.
*/
class PocketroCartGift extends HTMLElement {
  connectedCallback() {
    this.saveButton = this.querySelector('[data-cart-gift-save]');
    this.status = this.querySelector('[data-cart-gift-status]');
    this.saveButton?.addEventListener('click', () => this.save());
  }

  properties() {
    const wrapped = this.querySelector('[data-cart-gift-wrap]')?.checked;
    const message = this.querySelector('[data-cart-gift-message]')?.value.trim();
    const hidePrice = this.querySelector('[data-cart-gift-hide-price]')?.checked;
    const date = this.querySelector('[data-cart-gift-date]')?.value;
    const yes = this.dataset.yesValue;

    /* An empty string clears a property; Shopify drops it from the line. */
    return {
      [this.dataset.wrapKey]: wrapped ? yes : '',
      [this.dataset.messageKey]: message || '',
      [this.dataset.hidePriceKey]: hidePrice ? yes : '',
      [this.dataset.dateKey]: date || '',
    };
  }

  async save() {
    const lineCount = parseInt(this.dataset.lineCount, 10) || 0;
    const properties = this.properties();
    this.setBusy(true);

    try {
      for (let line = 1; line <= lineCount; line += 1) {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, properties }),
        });
      }
      document.dispatchEvent(new CustomEvent('pocketro:cart:gift-saved'));
      window.location.reload();
    } catch (error) {
      if (this.status) this.status.textContent = this.dataset.errorMessage || '';
      this.setBusy(false);
    }
  }

  setBusy(busy) {
    if (!this.saveButton) return;
    this.saveButton.disabled = busy;
    this.saveButton.setAttribute('aria-busy', busy ? 'true' : 'false');
  }
}

if (!customElements.get('pocketro-cart-gift')) {
  customElements.define('pocketro-cart-gift', PocketroCartGift);
}
